import { render, staticRenderFns } from "./DispatchForm.vue?vue&type=template&id=9e9a6426&scoped=true"
import script from "./DispatchForm.vue?vue&type=script&lang=js"
export * from "./DispatchForm.vue?vue&type=script&lang=js"
import style0 from "./DispatchForm.vue?vue&type=style&index=0&id=9e9a6426&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9e9a6426",
  null
  
)

export default component.exports